import axios from "axios";

export const getSection1 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/testomonial-page-s1-testimonial?populate=*`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
